/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edittabcrop2Inputs */

const en_edittabcrop2 = /** @type {(inputs: Edittabcrop2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crop`)
};

const de_edittabcrop2 = /** @type {(inputs: Edittabcrop2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuschneiden`)
};

/**
* | output |
* | --- |
* | "Crop" |
*
* @param {Edittabcrop2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const edittabcrop2 = /** @type {((inputs?: Edittabcrop2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edittabcrop2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edittabcrop2(inputs)
	return de_edittabcrop2(inputs)
});
export { edittabcrop2 as "editTabCrop" }